import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/admin?google_error=" + encodeURIComponent("Missing Google session"), { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);

    fetch(`${API}/auth/google/session?session_id=${encodeURIComponent(sessionId)}`, {
      credentials: "include",
    })
      .then(async (res) => {
        if (!res.ok) {
          const body = await res.json().catch(() => null);
          throw new Error(body?.detail || "Google sign-in failed");
        }
        return res.json();
      })
      .then((user) => {
        navigate("/admin", { replace: true, state: { user } });
      })
      .catch((err) => {
        navigate("/admin?google_error=" + encodeURIComponent(err.message || "Google sign-in failed"), {
          replace: true,
        });
      });
  }, [location.hash, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-ink text-slate-400">
      <p className="font-mono text-xs uppercase tracking-[0.3em]" data-testid="google-callback-status">
        Signing you in with Google…
      </p>
    </div>
  );
}
